// src/hooks/usePercelenConfig.js
import { useEffect, useState, useMemo } from "react";
import { colRefs, onSnapshot } from "../services/firestore";
import { ACTIVE_YEAR } from "../constants";

export default function usePercelenConfig({ year = ACTIVE_YEAR, enabled }) {
  const [percelen, setPercelen] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    setLoading(true);

    const unsub = onSnapshot(
      colRefs.percelen(year),
      (snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setPercelen(list);
        setLoading(false);
      },
      () => setLoading(false)
    );

    return () => unsub();
  }, [year, enabled]);

  const percelenMap = useMemo(() => {
    const m = new Map();
    for (const p of percelen) {
      m.set(p.perceel || p.id, p);
    }
    return m;
  }, [percelen]);

  const soortenPerPerceel = useMemo(() => {
    const m = {};
    for (const p of percelen) {
      const key = p.perceel || p.id;
      m[key] = Array.isArray(p.soorten) ? p.soorten : [];
    }
    return m;
  }, [percelen]);
 
  const actievePercelen = useMemo(
  () => percelen.filter(p => p.optionEnabled !== false),
  [percelen]
);


  return {
    percelen,           // array [{id, perceel, plantdatum, soorten, ...}]
    actievePercelen,     // alleen percelen met optionEnabled !== false (voor dropdowns)
    percelenMap,       // Map(perceelNaam → doc)
    soortenPerPerceel, // { [perceelNaam]: ['Koros', 'Ironman', ...] }
    loading,
  };
}
